import './index.scss';

import React from 'react';
import { useSelector } from 'react-redux';
import { selectActiveProductInfo } from 'core/redux/features/products/reducers/productInfos';
// import { AppState } from 'core/redux/reducers'

export default function InternalLinks() {
  const product = useSelector(selectActiveProductInfo);
  // const deviceType = useSelector((state: AppState) => state.deviceType)
  const links = product?.internal_links;
  return (
    <div className="int-links">
      {links &&
        links.map((link, arrIndex) => (
          <div key={arrIndex} className="int-links__content">
            <a href={link.url}>
              <div className="image">
                <img
                  // @ts-ignore
                  loading="lazy"
                  className="int-links__content__img"
                  src={link.thumbnail}
                  alt={link.label}
                />
              </div>
              <div className="int-links__link">
                <p className="int-links__text">{link.label}</p>
              </div>
            </a>
          </div>
        ))}
    </div>
  );
}
